import { createSlice } from '@reduxjs/toolkit';

// { userMessage: "ארעה שגיאה בטעינת המפה", error: error, message: error.message, level: 1/2/3/4 }
// levels: 1 - only log, 2 - log + message popup, 3 - log + message popup + page refresh, 4 - refresh + back (not coded), 5 - fatal error
// { userMessage: string to popup, error: string, message: string, level: 1|2|3|4, component, line }

const initialState = {
    error: null
}

const errorHandlingSlice = createSlice({
    name: "errorHandling",
    initialState,
    reducers: {
        throwError(state, action) {
            state.error = { ...action.payload };
        },
        resetError(state, action) {
            state.error = null;
        }
    }
})

export const errorHandlingActions = errorHandlingSlice.actions;
export default errorHandlingSlice
